import { Box, IconButton, List, ListItem, ListItemText, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip, useMediaQuery } from '@mui/material'
import React from 'react';
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useDispatch } from 'react-redux';
import { cartReducer } from '../redux/features/listSlice';
import CloseIcon from '@mui/icons-material/Close';

// STYLED DESIGN FOR TABLE CELL TO SEE COLORFULL
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#FFF4F4",
      color: "black",
      padding: '12px 16px',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: '14px',
      padding: '12px 16px',
    },
  }));
  
  // STYLED DESIGN FOR TABLE ROW TO SEE COLORFULL
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#FFFFFF",
    },
    "&:nth-of-type(even)": {
      backgroundColor: "#F4F7FC",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

const Cart = ({cartItemList,handleClose}) => {
    const dispatch = useDispatch()
    const [filterdData,setFilterdData] = React.useState(cartItemList)
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [expandedRows, setExpandedRows] = React.useState([]);
    const [expandState, setExpandState] = React.useState({});
    const isSmallScreen = useMediaQuery("(max-width:600px)");
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    
      const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
      };


// WHEN FILTERED VALUE IS CHANGED
      React.useMemo(()=>{
        if(filterdData.length > 0){
          sessionStorage.setItem("cartValues", JSON.stringify(filterdData))
          dispatch(cartReducer(filterdData))
        }else{
            sessionStorage.setItem("cartValues", JSON.stringify(filterdData))
          dispatch(cartReducer([]))
          // handleClose()
        }
          },[filterdData])

      // TABLE COLOR MATCHING HANDLER--------
const csshandler=(num)=>{
    if(num % 2 !== 0){
      return "#F4F7FC"
    }else{
      return "#fff"
    }
    }

// EXPANDABLE HANDLER---------
const handleEpandRow = (event, userId) => {
    // debugger;
    const currentExpandedRows = expandedRows;
    const isRowExpanded = currentExpandedRows.includes(userId);

    let obj = {};
    isRowExpanded ? (obj[userId] = false) : (obj[userId] = true);
    setExpandState(obj);

    if (obj[userId] === true) {
      setExpandedRows([userId]);
    } else {
      setExpandedRows([0]);
    }
  };

//  REMOVE FROM CART HANDLER-----------
const removeHandler=(value)=>{
    setFilterdData(filterdData.filter((obj) => obj.id !== value))
}

  return (
    <Box>
          <TableContainer component={Paper} sx={{ maxHeight: 440, backgroundColor: '#F4F7FC' }} >
                <Table sx={{ minWidth: 750 }} stickyHeader aria-label="sticky table">
                  <TableHead >
                    <StyledTableRow>
                      <StyledTableCell sx={{ fontWeight: "bold" }} ><Box sx={{ width: "max-content", fontWeight: "bold" }}>Test Code</Box></StyledTableCell>
                      <StyledTableCell sx={{ fontWeight: "bold" }}>Test Name</StyledTableCell>
                      {/* <StyledTableCell sx={{ fontWeight: "bold" }}>PackageId</StyledTableCell> */}
                      {/* <StyledTableCell sx={{ fontWeight: "bold" }}><Box sx={{ width: "max-content", fontWeight: "bold" }}>Package Name</Box></StyledTableCell> */}
                      <StyledTableCell sx={{ fontWeight: "bold" }}>MRP</StyledTableCell>
                      <StyledTableCell sx={{ fontWeight: "bold" }}>Methodology</StyledTableCell>
                      <StyledTableCell sx={{ fontWeight: "bold" }}>TAT</StyledTableCell>
                      <StyledTableCell sx={{ fontWeight: "bold", position: 'sticky', right: 0,textAlign:'center' }}>Actions</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>

                  <TableBody>
                    {filterdData.length > 0 ?(
                         filterdData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

                         .map((user, index) => {
                           return (
                             <React.Fragment key={index}>
                               <StyledTableRow colSpan={6}>
                                 <StyledTableCell>{user?.test_code || ""}</StyledTableCell>
                                 <StyledTableCell>{user?.test_name || ""}</StyledTableCell>
                                 {/* <StyledTableCell>{user?.package_id || ""}</StyledTableCell> */}
                                 {/* <StyledTableCell>{user?.packagename || ""}</StyledTableCell> */}
                                 <StyledTableCell><Box sx={{ display: "flex" }}><Box sx={{ marginRight: "1.5px" }}>₹ </Box><Box>{user?.mrp || ""}</Box> </Box></StyledTableCell>
                                 <StyledTableCell>{user?.methodology || ""}</StyledTableCell>
                                 <StyledTableCell><Box sx={{ width: "max-content" }}>{user?.tat || ""}</Box></StyledTableCell>
   
                                 <StyledTableCell style={{ position: 'sticky', background: csshandler(index+1), right: 0}}>
                                   <Box style={{ display: "flex" }}>
                                     <IconButton
                                       aria-label="visible"
                                       onClick={(event) =>
                                         handleEpandRow(event, user.id)
                                       }
                                       color="primary"
                                     >
                                       {expandState[user.id] ? (
                                         <VisibilityOffIcon sx={{ color: "#7D5C04" }} />
                                       ) : (
                                         <VisibilityIcon sx={{ color: "#FBBA00" }} />
                                       )}
                                     </IconButton>
                                       
                                     <Tooltip
                                       title={"Remove from list"}
                                       placement="bottom-start"
                                     >
                                       <IconButton onClick={()=>removeHandler(user.id)}>
                                       <CloseIcon color="error" />
                                     </IconButton>
                                     </Tooltip>
                                      
                                   </Box>
   
                                 </StyledTableCell>
                               </StyledTableRow>
                               {expandedRows.includes(user.id) ? (
                                  <>
                                  {isSmallScreen ? (
                                    <tr>
                                    <td colSpan="6" style={{ padding: 0 }}>
                                      <List className="custom-list">
                                        <ListItem sx={{display:'flex'}}>
                                          <ListItemText
                                            primary="Lab Name:"
                                            secondary={user?.centre_name || "N/A"}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Category:"
                                            secondary={user?.category || "N/A"}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Specimen Remarks:"
                                            secondary={user?.specimen_remarks || "N/A"}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Sample Type:"
                                            secondary={user?.sampleType_name || "N/A"}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Frequency:"
                                            secondary={user?.frequency || "N/A"}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="TAT:"
                                            secondary={user?.tat || "N/A"}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Temperature:"
                                            secondary={user?.temp || "N/A"}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Container:"
                                            secondary={user?.container || "N/A"}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Cut off:"
                                            secondary={user?.cut_off || "N/A"}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Methodology:"
                                            secondary={user?.methodology || "N/A"}
                                          />
                                        </ListItem>
                                        <ListItem>
                                          <ListItemText
                                            primary="Disease:"
                                            secondary={user?.disease_name || "N/A"}
                                          />
                                        </ListItem>
                                      </List>
                                    </td>
                                  </tr>
                                  ):(
                                    <tr>
                                    <td colSpan="6" style={{ padding: 0 }}>
                                      <List className="custom-list">
                                        <ListItem sx={{ display: 'flex', gap: 2 }}>
                                          <ListItemText
                                            primary="Lab Name:"
                                            secondary={user?.centre_name || "N/A"}
                                            sx={{ flex: 1 }}
                                          />
                                          <ListItemText
                                            primary="Category:"
                                            secondary={user?.category || "N/A"}
                                            sx={{ flex: 1 }}
                                          />
                                            <ListItemText
                                            primary="Specimen Remarks:"
                                            secondary={user?.specimen_remarks || "N/A"}
                                            sx={{ flex: 1 }}
                                          />
                                        </ListItem>
                                        <ListItem sx={{ display: 'flex', gap: 2 }}>
                                          <ListItemText
                                            primary="TAT:"
                                            secondary={user?.tat || "N/A"}
                                            sx={{ flex: 1 }}
                                          />
                                          <ListItemText
                                            primary="Temperature:"
                                            secondary={user?.temp || "N/A"}
                                            sx={{ flex: 1 }}
                                          />
                                           <ListItemText
                                            primary="Container:"
                                            secondary={user?.container || "N/A"}
                                            sx={{ flex: 1 }}
                                          />
                                        </ListItem>
                                        <ListItem sx={{ display: 'flex', gap: 2 }}>
                                          <ListItemText
                                            primary="Cut off:"
                                            secondary={user?.cut_off || "N/A"}
                                            sx={{ flex: 1 }}
                                          />
                                            <ListItemText
                                            primary="Methodology:"
                                            secondary={user?.methodology || "N/A"}
                                            sx={{ flex: 1 }}
                                          />
                                               <ListItemText
                                            primary="Disease:"
                                            secondary={user?.disease_name || "N/A"}
                                            sx={{ flex: 1 }}
                                          />
                                        </ListItem>
                                        <ListItem sx={{ display: 'flex', gap: 2 }}>
                                          <ListItemText
                                            primary="Sample Type:"
                                            secondary={user?.sampleType_name || "N/A"}
                                            sx={{ flex: 1 }}
                                          />
                                          <ListItemText
                                            primary="Frequency:"
                                            secondary={user?.frequency || "N/A"}
                                            sx={{ flex: 1 }}
                                          />
                                            <ListItemText
                                            // primary="Frequency:"
                                            // secondary={user?.frequency || "N/A"}
                                            sx={{ flex: 1 }}
                                          />
                                        </ListItem>
                                      </List>
                                    </td>
                                  </tr>
                                  
                                  )}
                                  </>
                                //  <tr>
                                //    <td colSpan="6" style={{ padding: 0 }}>
                                //      <List className="custom-list">
                                //        <ListItem>
                                //          <ListItemText
                                //            primary="Lab Name:"
                                //            secondary={user?.centre_name || "N/A"}
                                //          />
                                //        </ListItem>
                                //        <ListItem>
                                //          <ListItemText
                                //            primary="Category:"
                                //            secondary={user?.category || "N/A"}
                                //          />
                                //        </ListItem>
                                //        <ListItem>
                                //          <ListItemText
                                //            primary="Specimen Remarks:"
                                //            secondary={user?.specimen_remarks || "N/A"}
                                //          />
                                //        </ListItem>
                                //        <ListItem>
                                //          <ListItemText
                                //            primary="Sample Type:"
                                //            // secondary={user?.specimen_type || "N/A"}
                                //            secondary={user?.sampleType_name || "N/A"}
                                //          />
                                //        </ListItem>
                                //        <ListItem>
                                //          <ListItemText
                                //            primary="Frequency:"
                                //            secondary={user?.frequency || "N/A"}
                                //          />
                                //        </ListItem>
                                //        <ListItem>
                                //          <ListItemText
                                //            primary="TAT:"
                                //            secondary={user?.tat || "N/A"}
                                //          />
                                //        </ListItem>
                                //        <ListItem>
                                //          <ListItemText
                                //            primary="Temperature:"
                                //            secondary={user?.temp || "N/A"}
                                //          />
                                //        </ListItem>
                                //        <ListItem>
                                //          <ListItemText
                                //            primary="Container:"
                                //            secondary={user?.container || "N/A"}
                                //          />
                                //        </ListItem>
                                //        <ListItem>
                                //          <ListItemText
                                //            primary="Cut off:"
                                //            secondary={user?.cut_off || "N/A"}
                                //          />
                                //        </ListItem>
                                //        <ListItem>
                                //          <ListItemText
                                //            primary="Methodology:"
                                //            secondary={user?.methodology || "N/A"}
                                //          />
                                //        </ListItem>
                                //        <ListItem>
                                //          <ListItemText
                                //            primary="Disease:"
                                //            secondary={user?.disease_name || "N/A"}
                                //          />
                                //        </ListItem>
                                //      </List>
                                //    </td>
                                //  </tr>
                               ) : null}
                             </React.Fragment>
                           );
                         })
                    ):(
                        <TableRow>
                    <TableCell colSpan={8}>
                      <h6 style={{ textAlign: "center", color:'#5B5B5B' }}>No Data Available</h6>
                    </TableCell>
                  </TableRow>
                    )
                     }
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={filterdData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
    </Box>
  )
}

export default Cart